import React from 'react'
import HHeader from '../Components/Home/HHeader/HHeader'
import About from "../Components/Home/About/About"
import CeoMessage from '../Components/Home/CeoMessage/CeoMessage'
import Vision from '../Components/Home/Vision/Vision'
import WhyChoose from '../Components/Home/WhyChoose/WhyChoose'
// import OurTeam from '../Components/Home/OurTeam/OurTeam'
// import AffiliateTeam from '../Components/Home/AffiliateTeam/AffiliateTeam'
import InternationalPartners from '../Components/Home/InternationalPartners/InternationalPartners'
import OurNationalPartners from '../Components/Home/OurNationalPartners/OurNationalPartners'
import VisitUs from '../Components/Home/VisitUs/VisitUs'
import Footer from '../Components/Home/Footer/Footer'
import Mission from '../Components/Home/Mission/Mission'
import HNavbar from '../Components/Home/HNavbar/HNavbar'

const Home = () => {
  return (
    <>
      <HNavbar />
      <HHeader />
      <About />
      <CeoMessage />
      <Vision />
      <Mission/>
      <WhyChoose />
      {/* <OurTeam /> */}
      {/* <AffiliateTeam /> */}
      <InternationalPartners />
      <OurNationalPartners />
      <VisitUs />
      <Footer />
    </>
  )
}

export default Home